import { __extends } from "tslib";
import Tabla from '../Tabla';
import { InputText } from '@victorequena22/component-bootstrap';
import { Col, Card, Row, Button, InputGroup } from 'react-bootstrap';
import React from 'react';
var CardBuscador = /** @class */ (function (_super) {
    __extends(CardBuscador, _super);
    function CardBuscador(p) {
        var _this = _super.call(this, p) || this;
        _this.permiso = '';
        _this.Title = _this.Title.bind(_this);
        return _this;
    }
    CardBuscador.prototype.Title = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { className: 'float-right', onClick: function () {
                    _this.setState({ modal: true });
                } },
                ' ',
                React.createElement("i", { className: 'fa fa-edit' }),
                " NUEVO")));
    };
    CardBuscador.prototype.render = function () {
        var _a = this, Body = _a.Body, Buscador = _a.Buscador, Title = _a.Title;
        return (React.createElement(Card, null,
            React.createElement(Card.Header, { className: 'bg-info d-flex' },
                React.createElement(Title, null)),
            React.createElement(Card.Body, null,
                React.createElement(Buscador, null),
                React.createElement(Col, { md: 12 },
                    React.createElement(Body, null)))));
    };
    CardBuscador.prototype.Buscador = function () {
        return (React.createElement(Row, { className: 'd-flex', style: { paddingBottom: '15px' } },
            React.createElement(Col, { md: 9, className: 'mr-auto' },
                React.createElement(InputGroup, null,
                    React.createElement(InputGroup.Prepend, null,
                        React.createElement(InputGroup.Text, null, this.buscarLabel)),
                    React.createElement(InputText, { upper: true, setData: this.setState, update: 'buscar', value: this.state.buscar }),
                    React.createElement(InputGroup.Append, null,
                        React.createElement(Button, { variant: 'primary' },
                            React.createElement("i", { className: 'fa fa-search' }),
                            " BUSCAR"))))));
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    CardBuscador.prototype.set = function () { };
    CardBuscador.prototype.componentDidMount = function () {
        this.set();
    };
    return CardBuscador;
}(Tabla));
export default CardBuscador;
//# sourceMappingURL=Card.js.map